/* eslint-disable react/no-array-index-key */
import MojitoPresentation from 'mojito/presentation';
import { range } from 'mojito/utils';
import MojitoServices from 'mojito/services';

const {
    Text,
    FlexPane,
    SkeletonPart,
    GridLayout: { GridPane },
} = MojitoPresentation.Components;
const SportUtils = MojitoServices.SportsContent.Sports.utils;
const { useLocalizedParams } = MojitoPresentation.Hooks;

const SportGroupsListSkeleton = props => {
    const {
        mojitoTools: { config },
        headerText,
        isTopSportGroups,
    } = props;
    const {
        topSportGroups: { show: showTopSportGroupsSkeleton },
        allSportGroups: { show: showAllSportGroupsSkeleton },
    } = config;
    let leaguesToRender;

    if (showTopSportGroupsSkeleton && isTopSportGroups) {
        leaguesToRender = <TopLeagues config={config} headerText={headerText} />;
    } else if (showAllSportGroupsSkeleton && !isTopSportGroups) {
        leaguesToRender = <AllLeagues config={config} headerText={headerText} />;
    }

    return (
        <FlexPane config={config.container} class="ta-SportGroupsListSkeleton">
            {leaguesToRender}
        </FlexPane>
    );
};

const TopLeagues = ({ config, headerText }) => {
    const {
        topSportGroups: { numberOfSportGroups },
    } = config;
    const columnsToRender = range(config.sportGroupsGridColumns);

    return (
        <>
            <Header config={config} headerText={headerText} />
            <FlexPane config={config.leaguesContainer} class="ta-TopSportGroupsListSkeleton">
                <FlexPane config={config.listContainer}>
                    <GridPane
                        repeatedColumnsNum={config.sportGroupsGridColumns}
                        config={config.sportGroupsGrid}
                    >
                        {columnsToRender.map((_, colIndex) => (
                            <FlexPane key={colIndex} config={config.listGroupContainer}>
                                {range(numberOfSportGroups).map((_, index) => (
                                    <SkeletonPart key={index} config={config.leaguePlaceholder} /> // NOSONAR - The array index is used as a simple placeholder key.
                                ))}
                            </FlexPane>
                        ))}
                    </GridPane>
                </FlexPane>
            </FlexPane>
        </>
    );
};

const AllLeagues = ({ config, headerText }) => {
    const { sportId } = useLocalizedParams();
    const {
        allSportGroups: { numberOfRegions, numberOfSportGroups },
    } = config;
    const columnsToRender = range(config.sportGroupsGridColumns);

    return (
        <>
            {!SportUtils.isRacingSport(sportId) && (
                <Header config={config} headerText={headerText} />
            )}
            <FlexPane config={config.leaguesContainer} class="ta-AllSportGroupsListSkeleton">
                {range(numberOfRegions).map(index => (
                    <FlexPane key={index} config={config.listContainer}>
                        <GridPane
                            repeatedColumnsNum={config.sportGroupsGridColumns}
                            config={config.sportGroupsGrid}
                        >
                            {columnsToRender.map((_, colIndex) => (
                                <FlexPane key={colIndex} config={config.listGroupContainer}>
                                    {colIndex === 0 ? (
                                        <FlexPane config={config.regionContainer}>
                                            <SkeletonPart config={config.iconPlaceholder} />
                                            <SkeletonPart config={config.regionPlaceholder} />
                                        </FlexPane>
                                    ) : (
                                        <FlexPane />
                                    )}
                                    {range(numberOfSportGroups).map((_, idx) => (
                                        <SkeletonPart key={idx} config={config.leaguePlaceholder} /> // NOSONAR - The array index is used as a simple placeholder key.
                                    ))}
                                </FlexPane>
                            ))}
                        </GridPane>
                    </FlexPane>
                ))}
            </FlexPane>
        </>
    );
};

const Header = ({ config, headerText }) => (
    <FlexPane config={config.headerContainer}>
        <Text config={config.headerText}>{headerText}</Text>
    </FlexPane>
);

export default SportGroupsListSkeleton;
